// extracted by mini-css-extract-plugin
module.exports = {"DocsNavItem":"DocsNav_DocsNavItem__VrHf6","active":"DocsNav_active__fZb0r"};